import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {Trans} from "react-i18next";
import css from "./CardTitleCount.module.scss";

const CardTitleCount = ({i18nKey, count}) => (
  <Trans
    i18nKey={i18nKey}
    values={{count}}
    components={{
      count: <span className={classNames(css.count)} />
    }}
  />
);

CardTitleCount.propTypes = {
  i18nKey: PropTypes.string.isRequired,
  count: PropTypes.number
};

export default CardTitleCount;
